import { useEffect } from "react";
import { setLayoutDashboardTitle } from "../../../../store/ui-slice";
import useIsMobile from "../../../../hooks/useIsMobile";

// baseTitle: "Audit" (mobil) or "Audit Trado", see the config of the variant
const useEditorTitle = ({ dispatch, currentUrl, headerData, baseTitle }) => {
  const isMobile = useIsMobile();

  useEffect(() => {
    const isNew = currentUrl.includes("new");
    const kendaraan = headerData?.data_kendaraan;

    const kendaraanInfo = kendaraan
      ? isMobile
        ? kendaraan.nomor_polisi
        : `${kendaraan.nomor_polisi} | ${kendaraan.merek}`
      : "";

    dispatch(
      setLayoutDashboardTitle({
        title: `${isNew ? "New - " : ""}${baseTitle}${
          kendaraanInfo ? " - " + kendaraanInfo : ""
        }`,
      })
    );
  }, [currentUrl, headerData, isMobile]);
};

export default useEditorTitle;
